import type { HospitalPlace } from "./types";

export type MotherBedProfileOption = {
  id: number;
  name: string;
};

export const MOTHER_BED_PROFILE_OPTIONS: MotherBedProfileOption[] = [
  { id: 44, name: "Патологии беременности" },
  { id: 42, name: "Для беременных и рожениц (кроме патологии беременности)" },
  { id: 1, name: "Гинекологические для взрослых, включая для производства абортов" },
  { id: 66, name: "Гинекологические для детей, включая для производства абортов" },
  { id: 10, name: "Патология новорожденных и выхаживания недоношенных" },
  { id: 40, name: "Хирургические для новорожденных" },
  { id: 8, name: "Реанимационные для детей" },
];

export const MOTHER_BED_PROFILE_ID_SET = new Set(
  MOTHER_BED_PROFILE_OPTIONS.map((item) => item.id),
);

export const MOTHER_BED_PROFILE_DEFAULT_IDS = MOTHER_BED_PROFILE_OPTIONS.map(
  (item) => item.id,
);

export const MOTHER_FIXED_PLACE: HospitalPlace = "КС";
export const MOTHER_FIXED_FINANCE_SOURCE_ID = 9;
